// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type { IFilterOptionSchema } from './FilterOptionSchema';

export interface IFilterSchema {
  /** Название фильтра на русском(для вывода на клиент) **/
  displayName: string;
  /** Название фильтра на английском **/
  name: EName;
  /** Опции фильтра(варианты выбора) **/
  options: IFilterOptionSchema[];
  /** Тип фильтра(чекбокс или радиобаттон) **/
  type: EType;
}
export enum EName {
  /** Удобства **/
  'Amenities' = 'amenities',
  /** Год постройки **/
  'BuildYear' = 'buildYear',
  /** Подъезд **/
  'Entrance' = 'entrance',
  /** Этаж **/
  'Floor' = 'floor',
  /** Кол-во этаже в доме **/
  'FloorCount' = 'floorCount',
  /** Условия проживания **/
  'LivingConditions' = 'livingConditions',
  /** Сколько лет ремонту? **/
  'RepairAge' = 'repairAge',
  /** Укажите тип ремонта? **/
  'RepairType' = 'repairType',
  /** Удобства(загородка) **/
  'SuburbanConvenience' = 'suburbanConvenience',
  /** Где находится санузел **/
  'WcTypeLocation' = 'wcTypeLocation',
}
export enum EType {
  /** Чекбокс(квадратик), можно выбрать больше 1-го варианта **/
  'Checkbox' = 'checkbox',
  /** Радио баттон(кружочек), можно выбрать только 1 вариант **/
  'RadioButton' = 'radioButton',
}
